export const NO_PLANS_ROUTE = 'no-plans';
